// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lo-1";
export var messageSideRight = "_lo-2";
export var subscribeToBackInStockBubbleContainer = "_lo-0";